import { Injectable } from '@angular/core';
import { PlatformService } from './platform.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor(private readonly platformService: PlatformService) {}

  getLocalItem(key: string): string | null {
    if (!this.platformService.isBrowser()) {
      return null;
    }
    return localStorage.getItem(key);
  }

  setLocalItem(key: string, value: string): void {
    if (!this.platformService.isBrowser()) {
      return;
    }
    localStorage.setItem(key, value);
  }

  removeLocalItem(key: string): void {
    if (!this.platformService.isBrowser()) {
      return;
    }
    localStorage.removeItem(key);
  }

  clearLocal(): void {
    if (!this.platformService.isBrowser()) {
      return;
    }
    localStorage.clear();
  }

  getSessionItem(key: string): string | null {
    if (!this.platformService.isBrowser()) {
      return null;
    }
    return sessionStorage.getItem(key);
  }

  setSessionItem(key: string, value: string): void {
    if (!this.platformService.isBrowser()) {
      return;
    }
    sessionStorage.setItem(key, value);
  }

  removeSessionItem(key: string): void {
    if (!this.platformService.isBrowser()) {
      return;
    }
    sessionStorage.removeItem(key);
  }

  clearSession(): void {
    if (!this.platformService.isBrowser()) {
      return;
    }
    sessionStorage.clear();
  }
}